import { Breakpoints, Container, ContainerGutter, CTA, Layout, LayoutRowGap, styled, Text, TokenTextAppearance } from '@volkswagen-onehub/components-core';
import React from 'react';
import { useDispatch } from 'react-redux';
import { TriggerProps, useFaContent, useTransformToHtml } from 'src/feature-app';
import { ProspectsVentaForm } from 'src/forms';

const ImageWrapper = styled.div`
	img {
		width: 100%;
	}
`;

export function ProspectsTrigger(props: TriggerProps) {
	const { setSelectedJourney } = props;
	const faContent = useFaContent();
	const dispatch = useDispatch();
	const carlineDesc = faContent?.carlines && typeof faContent.carlines[0] == 'string' ? faContent.carlines[0].toUpperCase() : 'VOLKSWAGEN';

	return (
		<Layout
			appearance={
				faContent?.imageUrl
					? {
							[Breakpoints.default]: [
								{ name: '.', columns: 2 },
								{ name: 'a', columns: 20 },
								{ name: '.', columns: 2 },
								{ name: '.', columns: 2 },
								{ name: 'b', columns: 20 },
								{ name: '.', columns: 2 },
							],
							[Breakpoints.b560]: [
								{ name: '.', columns: 6 },
								{ name: 'a', columns: 12 },
								{ name: '.', columns: 6 },
								{ name: '.', columns: 6 },
								{ name: 'b', columns: 12 },
								{ name: '.', columns: 6 },
							],
							[Breakpoints.b960]: [
								{ name: '.', columns: 2 },
								{ name: 'a', columns: 6 },
								{ name: '.', columns: 2 },
								{ name: 'b', columns: 12 },
								{ name: '.', columns: 2 },
							],
					  }
					: {
							[Breakpoints.default]: [
								{ name: '.', columns: 2 },
								{ name: 'a', columns: 20 },
								{ name: '.', columns: 2 },
							],
					  }
			}
			rowGap={LayoutRowGap.dynamic0250}
		>
			{faContent?.imageUrl && (
				<ImageWrapper>
					<img src={faContent.imageUrl} alt="Image" />
				</ImageWrapper>
			)}

			<Container wrap={'always'} gutter={ContainerGutter.static300}>
				<Text appearance={TokenTextAppearance.copy200} bold>
					{faContent?.bodycopy2 ?? 'NUEVO ' + carlineDesc}
				</Text>
				<Text appearance={TokenTextAppearance.headline300}>
					<div dangerouslySetInnerHTML={useTransformToHtml(faContent?.headline ?? 'Volkswagen es <b>para quienes eligen ir más allá</b>')} />
				</Text>
				<Text appearance={TokenTextAppearance.copy200}>
					<div dangerouslySetInnerHTML={useTransformToHtml(faContent?.bodycopy ?? 'Para los que no solo buscan moverse, sino disfrutar el camino. Para quienes combinan estilo con propósito y ven lo extraordinario en cada día. ¿Es también para ti?')} />
				</Text>
				<CTA
					tag="button"
					onClick={(e) => {
						dispatch({ type: 'RESET_STATE' });
						e.preventDefault();
						setSelectedJourney(<ProspectsVentaForm />);
					}}
					emphasis="primary"
				>
					{faContent?.cta ?? 'Pide más información'}
				</CTA>
			</Container>
		</Layout>
	);
}
